<div class="booking-container" *ngIf="!loader && businessListData.length > 0">
  <div class="heading_sert">
    <h3>Enroll new member</h3>
  </div>
  <div class="chip_services_list">
    <mat-chip-listbox class="example-chip">
      <mat-chip
        (click)="selectBusiness(i)"
        *ngFor="let item of businessListData; let i = index"
        [ngClass]="{ 'Graceful-box-active': item.isSelected == 1 }"
        >{{ item.name }}</mat-chip
      >
    </mat-chip-listbox>
  </div>

  <div class="row">
    <div class="col-md-12" *ngIf="step == 1">
      <mat-card class="booking-form">
        <div class="serv_heading">
          <h3>New member {{ selectedBusiness.name }}</h3>
          <p>{{ selectedBusiness.address_line }}</p>
        </div>
        <!-- <mat-form-field appearance="outline" class="full-width">
          <mat-label>Name</mat-label>
          <input matInput type="text" placeholder="Enter name" />
        </mat-form-field> -->
        <div class="c_sectionmj">
          <div class="row">
            <div class="col-sm-12">
              <mat-form-field appearance="outline" class="country-code">
                <mat-label>Country Code</mat-label>
                <mat-select
                  [(ngModel)]="selectedCountryCode"
                  required
                  (selectionChange)="onCountrySelected($event)"
                >
                  <mat-select-trigger>
                    {{ selectedCountryCode.flag }}
                    {{ selectedCountryCode.name }}
                    {{ "(" + selectedCountryCode.dial_code + ")" }}
                  </mat-select-trigger>

                  <mat-option>
                    <ngx-mat-select-search
                      noEntriesFoundLabel="no results found"
                      name="countrysearch"
                      placeholderLabel="Enter country name"
                      [formControl]="searchString"
                      (keyup)="onKey()"
                    ></ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="let country of countryList"
                    [value]="country"
                  >
                    {{ country.flag }} {{ country.name }}
                    {{ "(" + country.dial_code + ")" }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-sm-12">
              <mat-form-field appearance="outline" class="phone-number">
                <mat-label>Phone</mat-label>
                <input
                (keyup.enter)="searchForAccountByPhone()"
                  [(ngModel)]="phone"
                  matInput
                  type="tel"
                  smNumericOnly
                  maxlength="17"
                  minlength="3"
                  placeholder="Enter phone number"
                />
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="cabh_sect">
          <button
            (click)="searchForAccountByPhone()"
            mat-flat-button
            color="accent"
            class="submit-btn"
            [disabled]="formChecker()"
          >
            Next
          </button>
        </div>
      </mat-card>
    </div>
    <div class="col-md-12" *ngIf="step == 2">
      <mat-card class="booking-form">
        <div>
          <div class="row">
            <div class="col-sm-12" style="margin-top: 100px">
              <div class="lkl">
                <div class="gfg_ig_ht">
                  <div class="pcg_img">
                    <a href="javascript:void(0)" class="card-icon">
                      <img
                        [src]="memberimg.img"
                        alt=""
                        onerror="this.src='../../../../assets/images/user-avatar.svg'"
                      />
                    </a>
                    <div class="un_ld_img" (click)="triggerFileInput.click()">
                      <a href="javascript:void(0)">
                        <mat-icon
                          style="
                            font-size: 22px;
                            color: #ffffff;
                            position: relative;
                            top: 4px;
                            left: -1px;
                          "
                          >add_a_photo</mat-icon
                        >
                        <input
                          #triggerFileInput
                          type="file"
                          accept="image/*"
                          name="img"
                          id="imagepick"
                          class="upload"
                          (change)="onUploadImage($event)"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <mat-form-field appearance="outline" style="width: 100%" required>
              <mat-label>Name</mat-label>
              <input [(ngModel)]="memberData.name" matInput required />
            </mat-form-field>
          </div>
          <!-- <div>
       <mat-form-field appearance="outline" style="width: 100%">
         <mat-label>Phone</mat-label>
         <input [(ngModel)]="memberData.customerPh" matInput  type="tel" smNumericOnly
         maxlength="10"/>
         
       </mat-form-field>
       </div> -->
          <div class="row g-2 justify-content-between phone-field">
            <mat-form-field appearance="outline" class="country-code col-3">
              <mat-label>Country Code</mat-label>
              <mat-select
                [disabled]="isPhoneDisabled"
                [(ngModel)]="selectedCountryCode"
                required
                (selectionChange)="onCountrySelected($event)"
              >
                <mat-select-trigger>
                  {{ selectedCountryCode.flag }} {{ selectedCountryCode.name }}
                  {{ "(" + selectedCountryCode.dial_code + ")" }}
                </mat-select-trigger>
                <mat-option>
                  <ngx-mat-select-search
                    noEntriesFoundLabel="no results found"
                    name="countrysearch"
                    placeholderLabel="Enter country name"
                    [formControl]="searchString"
                    (keyup)="onKey()"
                  ></ngx-mat-select-search>
                </mat-option>
                <mat-option
                  *ngFor="let country of countryList"
                  [value]="country"
                >
                  {{ country.flag }} {{ country.name }}
                  {{ "(" + country.dial_code + ")" }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="mobile_form col-9" appearance="outline">
              <mat-label>Phone</mat-label>
              <input
                required
                [disabled]="isPhoneDisabled"
                [(ngModel)]="memberData.phone"
                matInput
                type="tel"
                smNumericOnly
                maxlength="17"
                minlength="3"
              />
              <mat-hint
                style="color: red; font-size: 13px"
                align="end"
                *ngIf="
                  memberData.phone &&
                  memberData.phone != '' &&
                  memberData.phone.length < 3
                "
                >Enter a valid phone number.</mat-hint
              >
            </mat-form-field>
          </div>
          <div>
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>Address</mat-label>
              <input
                [(ngModel)]="memberData.address"
                matInput
                maxlength="400"
              />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field
              class="w-100"
              appearance="outline"
              class="col-12"
              (click)="picker0.open()"
              style="padding: 0px"
            >
              <mat-label>DOB</mat-label>
              <input
                matInput
                [matDatepicker]="picker0"
                [(ngModel)]="memberData.dob"
                readonly
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker0"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker0 disabled="false"></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="radio_group">
            <label>Gender: </label>
            <mat-radio-group [(ngModel)]="memberData.gender">
              <div class="sp_list_group">
                <div class="sp_list">
                  <mat-radio-button value="Male">Male</mat-radio-button>
                </div>
                <div class="sp_list">
                  <mat-radio-button value="Female">Female</mat-radio-button>
                </div>
                <div class="sp_list">
                  <mat-radio-button value="Others">Others</mat-radio-button>
                </div>
              </div>
            </mat-radio-group>
          </div>
          <div>
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>Email</mat-label>
              <input matInput [(ngModel)]="memberData.email" />
            </mat-form-field>
          </div>
          <div>
            <mat-form-field
              class="w-100"
              appearance="outline"
              class="col-12"
              (click)="picker1.open()"
              style="padding: 0px"
            >
              <mat-label>Start date</mat-label>
              <input
                matInput
                [matDatepicker]="picker1"
                [(ngModel)]="memberData.start_date"
                readonly
                required
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker1"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker1 disabled="false"></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
         <div class="cabh_sect">
          <button mat-button (click)="goback()">Back</button>
          <button
            (click)="gonext()"
            [disabled]="getDisabledStatus()"
            mat-flat-button
            color="accent"
            class="submit-btn"
          >
            Next
          </button>
        </div>
      </mat-card>
    </div>
    <div class="col-md-12" *ngIf="step == 3">
      <mat-card class="booking-form">
        <div>
          <div *ngIf="isEntityIndividual == '1'">
            <h3 class="servicet_heading" style="margin-bottom: 16px">
              Scheduled day and time*
            </h3>
            <div
              class="chip_cont"
              *ngFor="let item of selectedDays; let i = index"
            >
              <mat-chip-listbox
                aria-label="Fish selection"
                class="mb-3 matchp"
                style="
                  border-bottom: 1px solid #e2e2e2;
                  padding-bottom: 15px;
                  width: 100%;
                  display: block;
                "
              >
                <div class="close_heradinrt">
                  <!-- <p style="cursor: pointer;" >Remove</p> -->
                  <mat-icon (click)="removeSelectedDay(i)">close</mat-icon>
                </div>
                <div>
                  <mat-chip class="selected">{{ item.day.dayName }} </mat-chip>
                  <mat-chip class="selected"
                    >{{ tConv24(item.startTime) }} - {{ tConv24(item.endTime) }}
                  </mat-chip>
                </div>
              </mat-chip-listbox>
            </div>
            <button
              class="add-new-btn"
              (click)="openTimings()"
              mat-flat-button
              color="accent"
            >
              <mat-icon>add</mat-icon>
              Add a day
            </button>
          </div>
          <h3 class="servicet_heading" style="margin-bottom: 16px">
            Service type
          </h3>
          <div class="form-group service-button">
            <mat-chip-listbox class="example-chip">
              <mat-chip
                *ngIf="selectedBusiness.shop_service_status != 2"
                [ngClass]="{ selected: selectedServiceType == '1' }"
                (click)="changeServiceType('1')"
                >{{
                  isEntityIndividual == "0"
                    ? "Shop service"
                    : "In-premise service"
                }}</mat-chip
              >
              <mat-chip
                *ngIf="selectedBusiness.home_service_status != 2"
                [ngClass]="{ selected: selectedServiceType == '0' }"
                (click)="changeServiceType('0')"
                >Home service</mat-chip
              >
              <mat-chip
                *ngIf="selectedBusiness.virtual_service_status != 2"
                [ngClass]="{ selected: selectedServiceType == '2' }"
                (click)="changeServiceType('2')"
                >Virtual service</mat-chip
              >
            </mat-chip-listbox>
          </div>
          <!-- SERVICES -->
          <h3
            class="servicet_heading"
            style="margin-bottom: 0px"
            *ngIf="isEntityIndividual == '0'"
          >
            {{
              selectedServiceType == "1"
                ? "Shop services / packages"
                : selectedServiceType == "0"
                ? "Home services / packages"
                : "Virtual services / packages"
            }}
          </h3>
          <h3
            class="servicet_heading"
            style="margin-bottom: 0px"
            *ngIf="isEntityIndividual == '1'"
          >
            {{
              selectedServiceType == "1"
                ? "In-premise services / packages"
                : selectedServiceType == "0"
                ? "Home services / packages"
                : "Virtual services / packages"
            }}
          </h3>
          <div class="chip_cont" style="padding: 20px 0px">
            <mat-chip-listbox
              class="example-chip"
              *ngIf="serviceList.length > 0"
            >
              <div *ngFor="let item of serviceList">
                <mat-chip *ngIf="item.toShow" (click)="selectServices(item)"
                  >{{ item.serviceName }}
                </mat-chip>
              </div>
            </mat-chip-listbox>
            <p *ngIf="serviceList.length == 0">No service added</p>
          </div>
          <!-- PRODUCTS -->
          <h3
            class="servicet_heading"
            style="margin-bottom: 0px"
            *ngIf="productsList.length > 0"
          >
            Sellable products
          </h3>
          <div
            class="chip_cont"
            style="padding: 20px 0px"
            *ngIf="productsList.length > 0"
          >
            <mat-chip-listbox
              class="example-chip"
              *ngIf="productsList.length > 0"
            >
              <div *ngFor="let item of productsList">
                <mat-chip *ngIf="item.toShow" (click)="selectProducts(item)"
                  >{{ item.product_name }}
                </mat-chip>
              </div>
            </mat-chip-listbox>
            <p *ngIf="productsList.length == 0">No product added</p>
          </div>
          <!-- SELECTED SERVICES -->
          <h3
            style="color: #222; font-weight: bold"
            *ngIf="selectedJobs.length > 0"
          >
            Job selected
          </h3>
          <div class="" *ngIf="selectedJobs.length > 0">
            <div
              class="job_complete_section"
              *ngFor="let item of selectedJobs; let i = index"
            >
              <div class="first_div">
                <div
                  style="
                    display: inline-block;
                    width: fit-content;
                    background: #ffc107;
                    padding: 8px 20px;
                    border-radius: 34px;
                    margin-bottom: 20px;
                  "
                >
                  <p style="margin: 0px; font-weight: 500; font-size: 16px">
                    {{ item.serviceName }}
                  </p>
                </div>
                <!-- <mat-icon style="    font-size: 20px;
                font-weight: 900;
                color: #000;
                position: relative;
                top: 4px;
                margin-left: 10px;">close</mat-icon> -->
                <div class="produce_bill_sec">
                  <div>
                    <span
                      style="
                        margin-left: 10px;
                        border: 1px solid #a2a2a2;
                        padding: 10px;
                        border-radius: 10px;
                      "
                    >
                      <button
                        (click)="decreaseServiceCount(item, i)"
                        style="
                          background: none;
                          border: 1px solid #a2a2a2;
                          border-radius: 25px;
                          width: 25px;
                          height: 25px;
                        "
                      >
                        <mat-icon
                          class="material-icons-outlined"
                          style="
                            font-size: 16px;
                            position: relative;
                            top: 2px;
                            left: -3px;
                            color: #666666;
                            height: auto;
                            width: auto;
                          "
                          >remove</mat-icon
                        >
                      </button>
                      <span style="margin: 0 15px">
                        {{ item.selectedCount }}
                      </span>
                      <button
                        (click)="increaseServiceCount(item, i)"
                        style="
                          background: none;
                          border: 1px solid #a2a2a2;
                          border-radius: 25px;
                          width: 25px;
                          height: 25px;
                        "
                      >
                        <mat-icon
                          style="
                            font-size: 16px;
                            position: relative;
                            top: 2px;
                            left: -3px;
                            color: #666666;
                            height: auto;
                            width: auto;
                          "
                          class="material-icons-outlined"
                          >add</mat-icon
                        >
                      </button>
                    </span>
                  </div>
                  <div class="second-div" style="padding: 0">
                    <div class="th_heading">
                      <input
                        [(ngModel)]="item.price"
                        matInput
                        smDecimalOnly
                        type="number"
                        (ngModelChange)="changeServicePrice(item)"
                      />
                    </div>
                  </div>
                </div>
                <div class="bill_down_flex">
                  <span
                    (click)="removeSelectedJobs(item)"
                    style="
                      text-decoration: underline;
                      margin-left: 20px;
                      display: inline-block;
                      cursor: pointer;
                    "
                  >
                    Remove
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- SELECTED PRODUCTS -->
          <h3
            style="color: #222; font-weight: bold"
            *ngIf="selectedProducts.length > 0"
          >
            Selected products
          </h3>
          <div class="" *ngIf="selectedProducts.length > 0">
            <div
              class="job_complete_section"
              *ngFor="let item of selectedProducts; let i = index"
            >
              <div class="first_div">
                <div
                  style="
                    display: inline-block;
                    width: fit-content;
                    background: #ffc107;
                    padding: 8px 20px;
                    border-radius: 34px;
                    margin-bottom: 20px;
                  "
                >
                  <p style="margin: 0px; font-weight: 500; font-size: 16px">
                    {{ item.product_name }}
                  </p>
                </div>
                <!-- <mat-icon style="    font-size: 20px;
                font-weight: 900;
                color: #000;
                position: relative;
                top: 4px;
                margin-left: 10px;">close</mat-icon> -->
                <div class="produce_bill_sec">
                  <div style="display: inline-block">
                    <span
                      style="
                        margin-left: 10px;
                        border: 1px solid #a2a2a2;
                        padding: 10px;
                        border-radius: 10px;
                      "
                    >
                      <button
                        (click)="decreaseProductCount(item, i)"
                        style="
                          background: none;
                          border: 1px solid #a2a2a2;
                          border-radius: 25px;
                          width: 25px;
                          height: 25px;
                        "
                      >
                        <mat-icon
                          class="material-icons-outlined"
                          style="
                            font-size: 16px;
                            position: relative;
                            top: 2px;
                            left: -3px;
                            color: #666666;
                            height: auto;
                            width: auto;
                          "
                          >remove</mat-icon
                        >
                      </button>
                      <span style="margin: 0 15px">
                        {{ item.selectedCount }}
                      </span>
                      <button
                        (click)="increaseProductCount(item, i)"
                        style="
                          background: none;
                          border: 1px solid #a2a2a2;
                          border-radius: 25px;
                          width: 25px;
                          height: 25px;
                        "
                      >
                        <mat-icon
                          style="
                            font-size: 16px;
                            position: relative;
                            top: 2px;
                            left: -3px;
                            color: #666666;
                            height: auto;
                            width: auto;
                          "
                          class="material-icons-outlined"
                          >add</mat-icon
                        >
                      </button>
                    </span>
                  </div>
                  <div class="second-div" style="padding: 0">
                    <div class="th_heading">
                      <input
                        [(ngModel)]="item.price"
                        matInput
                        smDecimalOnly
                        type="number"
                        (ngModelChange)="changeProductPrice(item)"
                      />
                    </div>
                  </div>
                </div>
                <div class="bill_down_flex">
                  <span
                    (click)="removeSelectedProducts(item)"
                    style="
                      text-decoration: underline;
                      margin-left: 20px;
                      display: inline-block;
                      cursor: pointer;
                    "
                  >
                    Remove
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- create invice new design added -->
          <div class="other_itemi_secty">
            <div class="oth_headingrt">
              <h3>Other items</h3>
            </div>
            <form [formGroup]="form">
              <div formArrayName="items">
                <div
                  *ngFor="let item of items.controls; let i = index"
                  [formGroupName]="i"
                  class="repect_under"
                >
                  <div class="row">
                    <div class="col-sm-3">
                      <div class="item_name_tht">
                        <mat-form-field appearance="outline" class="full-width">
                          <mat-label>Item name</mat-label>
                          <input
                            matInput
                            formControlName="name"
                            [matAutocomplete]="auto"
                            type="text"
                            placeholder="Enter item name"
                          />
                          <mat-autocomplete
                            #auto="matAutocomplete"
                            [displayWith]="displayItemName"
                          >
                            <mat-option
                              *ngFor="let option of filteredOptions[i] | async"
                              [value]="option"
                            >
                              {{ option.item_name }}
                            </mat-option>
                          </mat-autocomplete>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-sm-3">
                      <mat-form-field appearance="outline">
                        <mat-select class="w-100" formControlName="tax_slab">
                          <mat-option value="default">
                            Select a tax
                          </mat-option>
                          <mat-option
                            [value]="item.hash_id"
                            *ngFor="let item of taxSlabData"
                          >
                            {{
                              isEntityForeign == "0"
                                ? item.tax_name
                                : item.slab_name
                            }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="adsfer">
                      <div
                        class="plus_tht newclassw"
                        style="padding-top: 5px; margin-bottom: 0px"
                      >
                        <mat-icon class="serv_x">close</mat-icon>
                        <div class="inc_dec_cont">
                          <span
                            class="cont_span"
                            style="
                              top: 2px;
                              border: 1px solid #a2a2a2;
                              padding: 13px !important;
                              border-radius: 10px;
                              position: relative;
                              bottom: 0px;
                              width: 125px;
                              display: block;
                              margin-right: 10px;
                            "
                          >
                            <button
                              type="button"
                              class="inc_dec_btn"
                              (click)="decreaseCount(i)"
                            >
                              <mat-icon>remove</mat-icon>
                            </button>
                            <span style="margin: 0 15px">{{
                              item.get("count")!.value
                            }}</span>
                            <button
                              type="button"
                              class="inc_dec_btn"
                              (click)="increaseCount(i)"
                            >
                              <mat-icon>add</mat-icon>
                            </button>
                          </span>
                        </div>
                        <div class="item_name_tht">
                          <mat-form-field
                            appearance="outline"
                            class="full-width"
                            style="width: 97%"
                          >
                            <mat-label>Item price</mat-label>
                            <input
                              matInput
                              formControlName="price"
                              placeholder="Enter item price"
                              smDecimalOnly
                              type="number"
                            />
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                    <span class="remove_btn" (click)="removeFormField(i)"
                      >Remove</span
                    >
                  </div>
                </div>
              </div>
              <div class="add_item_btbh">
                <button
                  type="button"
                  mat-flat-button
                  color="accent"
                  (click)="addFormField()"
                >
                  <mat-icon>add</mat-icon>
                  Add item
                </button>
              </div>
            </form>
          </div>
        </div>
        <div class="cabh_sect">
          <button mat-button (click)="goback()">Back</button>
          <button
            [disabled]="getDisabledStatus()"
            (click)="gonext()"
            mat-flat-button
            color="accent"
            class="submit-btn"
          >
            Next
          </button>
        </div>
      </mat-card>
    </div>
    <div class="col-md-12" *ngIf="step == 4">
      <mat-card class="booking-form">
        <div>
          <div class="radio_group">
            <div class="billing_prised">
              <label>Billing period: </label>
            </div>
            <div class="list-hywek">
              <mat-radio-group [(ngModel)]="memberData.billing_period">
                <mat-radio-button [value]="1">Weekly</mat-radio-button>
                <mat-radio-button [value]="2">Monthly</mat-radio-button>
                <mat-radio-button [value]="4">3 months</mat-radio-button>
                <mat-radio-button [value]="5">6 months</mat-radio-button>
                <mat-radio-button [value]="3">Yearly</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          <div class="radio_group">
            <div class="billing_prised">
              <label>Bill type: </label>
            </div>
            <div class="list-hywek">
              <mat-radio-group [(ngModel)]="pay_in_advance">
                <mat-radio-button [value]="0">Normal payment</mat-radio-button>
                <mat-radio-button [value]="1">Advance payment</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          <div>
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label *ngIf="isEntityIndividual == '1'"
                >Select default trainer
              </mat-label>
              <mat-label *ngIf="isEntityIndividual == '0'"
                >Select default attendee
              </mat-label>
              <mat-select [(ngModel)]="selectedEmployee">
                <mat-option selected [value]="0"> None </mat-option>
                <mat-option *ngFor="let item of employeeList" [value]="item">
                  {{ item.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field appearance="outline" style="width: 100%">
              <mat-label>Notes</mat-label>
              <textarea
                [(ngModel)]="memberData.note"
                [maxLength]="400"
                matInput
              ></textarea>
              <!-- <mat-icon matSuffix class="material-icons-outlined">message</mat-icon> -->
            </mat-form-field>
          </div>
          <div
            style="
              border-bottom: 1px solid lightgray;
              padding-bottom: 10px;
              padding-top: 14px;
            "
          >
            <div
              class="shop_flexc"
              style="margin-bottom: 20px; padding: 0 18px 0 0"
            >
              <div class="clrt_heading" style="font-size: 16px">
                Subscription fee
              </div>
              <div class="" style="text-align: right; font-size: 16px">
                {{ memberData.price.toFixed(2) }}
              </div>
            </div>
            <div
              class="shop_flexc"
              style="margin-bottom: 20px; padding: 0 18px 0 0"
              *ngIf="memberData.coupon_code"
            >
              <div class="clrt_heading" style="font-size: 16px">
                Coupon discount
              </div>
              <div class="" style="text-align: right; font-size: 16px">
                {{ memberData?.coupon_discount.toFixed(2) }}
              </div>
            </div>
            <div class="shop_flexc" style="padding: 0 18px 0 0">
              <div class="clrt_heading" style="font-size: 16px">Discount</div>
              <div class="" style="text-align: right">
                <input
                  [(ngModel)]="memberData.discount"
                  matInput
                  smDecimalOnly
                  type="number"
                  style="
                    width: 100px;
                    border: 1px solid #8d8d8d;
                    padding: 0px 15px;
                    border-radius: 5px;
                  "
                />
              </div>
            </div>
          </div>
          <div>
            <div
              class="shop_flexc"
              style="margin-top: 20px; margin-bottom: 40px; padding: 0 18px 0 0"
            >
              <div
                class="clrt_heading"
                style="font-size: 16px; font-weight: bold; color: #222"
              >
                Net payable
              </div>
              <div
                style="
                  text-align: right;
                  font-size: 16px;
                  font-weight: bold;
                  color: #222;
                "
              >
                {{
                  (
                    memberData.price -
                    memberData.discount -
                    memberData?.coupon_discount
                  ).toFixed(2)
                }}
              </div>
            </div>
          </div>
        </div>
        <div class="cabh_sect">
          <button mat-button (click)="goback()">Back</button>
          <button
            *ngIf="selectedServiceType == '1'"
            [disabled]="
              selectedJobs.length == 0 ||
              selectedDaysChecker() ||
              formChecker() ||
              namechecker() ||
              form.invalid ||
              !memberData.start_date
            "
            (click)="onPost()"
            mat-flat-button
            color="accent"
            class="submit-btn"
            >
            Confirm
          </button>
          <button
            *ngIf="selectedServiceType == '0' || selectedServiceType == '2'"
            [disabled]="getDisabledStatus()"
            (click)="gonext()"
            mat-flat-button
            color="accent"
            class="submit-btn"
          >
            Next
          </button>
        </div>
      </mat-card>
    </div>
    <div class="col-md-12" *ngIf="step === 5 && toShowSessionInfo">
      <mat-card class="booking-form">
         <div>
    <div>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Online meeting link</mat-label>
        <input [(ngModel)]="online_session_link" matInput maxlength="400" />
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>App download (if there any) </mat-label>
        <textarea
          [(ngModel)]="online_session_app"
          [maxLength]="400"
          matInput
        ></textarea>
        <!-- <mat-icon matSuffix class="material-icons-outlined">message</mat-icon> -->
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Other session info</mat-label>
        <textarea
          [(ngModel)]="online_session_notes"
          [maxLength]="400"
          matInput
        ></textarea>
        <!-- <mat-icon matSuffix class="material-icons-outlined">message</mat-icon> -->
      </mat-form-field>
    </div>
    <p style="color: #888;">
            Add the detailed online meeting info with the link to join. Also include if there any mobile/desktop app needed, so your member have everything you need to go online with your service.
          </p>
  </div>
   <div class="cabh_sect">
          <button mat-button (click)="goback()">Back</button>
          <button
            [disabled]="
              selectedJobs.length == 0 ||
              selectedDaysChecker() ||
              formChecker() ||
              namechecker() ||
              form.invalid ||
              !memberData.start_date || 
              !online_session_link
            "
            (click)="onPost()"
            mat-flat-button
            color="accent"
            class="submit-btn"
            >
            Confirm
          </button>
        </div>
      </mat-card>
      </div>
        <div class="col-md-12" *ngIf="step === 5 && toShowMap">
      <mat-card class="booking-form">
         <div class="col-sm-12" style="padding: 0">
      <div class="content" style="">
        <!-- <h1>New business creation (step 4 of 4)</h1> -->
        <div class="sub_headingt">
          <!-- <h3></h3> -->
        </div>
        <div class="map-holder">
          <div
            #mapContainer
            id="map-container"
            style="height: 300px; width: 100%"
          ></div>
        </div>
        <div>
          <p style="color: #888; margin-bottom: 30px">
            Add address where you would like to be served. You can drag the map pointer for a precise location. A well defined address will help the service provider to locate the address correctly.
          </p>
        </div>
        <div class="map-form-holder">
          <!-- <h4>Address</h4> -->
          <mat-form-field appearance="outline">
            <mat-label>Enter location</mat-label>
            <input
              (input)="onInputChange()"
              placeholder="Select a location"
              [matAutocomplete]="auto"
              [(ngModel)]="this.formattedAddress"
              matInput
              #input
            />
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option
                *ngFor="let item of googleAutoCompleteItems"
                (click)="selectItem(item)"
              >
                {{ item.description }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div class="">
          <!-- <h4>Address</h4> -->
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Zipcode</mat-label>
            <input
              [(ngModel)]="this.selectedLocation.zip"
              type="text"
              matInput
              #input
            />
          </mat-form-field>
        </div>
        <div class="">
          <!-- <h4>Address</h4> -->
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>House number</mat-label>
            <input [(ngModel)]="houseNumber" type="text" matInput #input />
          </mat-form-field>
        </div>
        <div class="">
          <!-- <h4>Address</h4> -->
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Street name</mat-label>
            <input [(ngModel)]="streetName" type="text" matInput #input />
          </mat-form-field>
        </div>
        <div class="">
          <!-- <h4>Address</h4> -->
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Landmark</mat-label>
            <input [(ngModel)]="landmark" type="text" matInput #input />
          </mat-form-field>
        </div>
        <div class="">
          <div class="row g-2 justify-content-between phone-field">
            <mat-form-field appearance="outline" class="country-code col-3">
              <mat-label>Country Code</mat-label>
              <mat-select
                [(ngModel)]="contactselectedCountryCode"
                required
                (selectionChange)="onCountrySelected($event)"
              >
                <mat-select-trigger>
                  {{ "(" + contactselectedCountryCode.dial_code + ")" }}
                </mat-select-trigger>

                <mat-option>
                  <ngx-mat-select-search
                    noEntriesFoundLabel="no results found"
                    name="countrysearch"
                    placeholderLabel="Enter country name"
                    [formControl]="searchString"
                    (keyup)="onKey()"
                  ></ngx-mat-select-search>
                </mat-option>
                <mat-option
                  *ngFor="let country of countryList"
                  [value]="country"
                >
                  {{ "(" + country.dial_code + ")" }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="mobile_form col-9" appearance="outline">
              <mat-label>Contact phone</mat-label>
              <input
                matInput
                type="tel"
                [(ngModel)]="contactPhone"
                minLength="3"
                maxlength="17"
              />
              <!-- <mat-hint
        style="color: red; font-size: 13px"
        align="end"
        *ngIf="
          newbookingData.customerPh &&
          newbookingData.customerPh != '' &&
          newbookingData.customerPh.length < 3
        "
        >Enter a valid phone number.</mat-hint 
      >-->
            </mat-form-field>
          </div>
        </div>
      </div>
      <!-- <div class="footer">
      <button mat-button style="font-size: 16px" (click)="onClickBack(4)">
        <mat-icon>arrow_back</mat-icon>
        Back
      </button>
      <button
        (click)="onSubmit()"
        [disabled]="!formattedAddress"
        mat-flat-button
        color="accent"
        class="next"
      >
        Save
      </button>
    </div> -->
    </div>
    <div class="cabh_sect">
          <button mat-button (click)="goback()">Back</button>
          <button
            [disabled]="
              selectedJobs.length == 0 ||
              selectedDaysChecker() ||
              formChecker() ||
              namechecker() ||
              form.invalid ||
              !memberData.start_date
            "
            (click)="onPost()"
            mat-flat-button
            color="accent"
            class="submit-btn"
            >
            Confirm
          </button>
        </div>
      </mat-card>
      </div>
  </div>
</div>

<section class="nw_service_th" *ngIf="!loader && businessListData.length == 0">
    <div class="">
        <div class="heading_sert">
            <h3>All members</h3>
        </div>
    </div>

       <!-- Placeholder design html start -->
       <div class="placeholder_started__business">
        <div class="row">
          <div class="col-sm-4 col-md-4 col-12" *ngIf="!isEmployeeAndHasBusinessButDoesNotHaveAccess">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/business-create.png" style="width: 110px;">
                 </div>
                 <mat-card-title>No business added yet.</mat-card-title>
                 <mat-card-content>To add your members you need to create a business first. Members will be added under that business.
                </mat-card-content>
                 <div class="create_btnyh">
                    <button mat-flat-button color="primary" (click)="selectcountry()">
                        <mat-icon>add</mat-icon> 
                        Create a business
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
       <div class="col-sm-4 col-md-4 col-12" *ngIf="isEmployeeAndHasBusinessButDoesNotHaveAccess">
                <div class="dashboard_new" >
                  <mat-card appearance="outlined" style="">
                      <div class="upload_sectio">
                     <div class="icm_img">
                        <img src="./assets/images/business-create.png" style="width: 110px;">
                     </div>
                     <mat-card-title>Access denied.</mat-card-title>
                     <mat-card-content> Business owner with valid premium business subscription or an active employee with permission can access this section. Check current plans. Recharge pack if expired.
                    </mat-card-content>
                     
                     </div>
                  </mat-card>
               </div>
              </div>
              <div class="col-sm-4 col-md-4 col-12">
               <div class="dashboard_new">
                <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/all-members.svg">
                 </div>
                 <mat-card-title>How to manage members?</mat-card-title>
                        <mat-card-content> Check our <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')"> help document </span> to manage membership in your business. You can check this video as well to get step by step help. 

                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary" (click)="openvideo()">
                       <mat-icon>play_arrow</mat-icon>
                       Watch video
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4 col-md-4 col-12">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/helpsupport.png">
                 </div>
                 <mat-card-title>Having any issue?</mat-card-title>
                 <mat-card-content>For any difficulties in adding members or if there's any issue while adding members, contact our support team.
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary" (click)="opencontact()">
                       <mat-icon>support_agent</mat-icon>
                       Contact support
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
        </div>
    
      </div>
      <!-- Placeholder design html start -->
    
      
</section>